module.exports = __webpack_public_path__ + "static/media/Sept21-17.017ec725.png";